module.exports = __webpack_public_path__ + "img/banner.1a0f00a7.png";